<template>
  <span></span>
</template>
<script>
import Vue from "vue";

import VueGitHubButtons from "vue-github-buttons";
import "vue-github-buttons/dist/vue-github-buttons.css";
import { Switch as LSwitch } from "src/components";

import SocialSharing from "vue-social-sharing";

const VueSelect = {
  install(Vue, options) {
    Vue.component("SocialSharing", SocialSharing);
  },
};
Vue.use(VueSelect);
Vue.use(VueGitHubButtons, { useCache: true });
export default {
  components: {
    // LSwitch,
  },
  props: {
    color: {
      type: String,
      default: "black",
    },
    sidebarMini: Boolean,
    fixedNavbar: Boolean,
  },
  data() {
    return {
      documentationLink:
        "https://vue-now-ui-dashboard-laravel.creative-tim.com/documentation/#/getting-started",
      shareUrl:
        "https://www.creative-tim.com/product/vue-now-ui-dashboard-laravel",
      buyUrl:
        "https://www.creative-tim.com/product/vue-now-ui-dashboard-pro-laravel",
      downloadUrl:
        "https://www.creative-tim.com/product/vue-now-ui-dashboard-laravel",
      gitLink:
        "https://github.com/creativetimofficial/vue-now-ui-dashboard-laravel",
      isOpen: false,
      sidebarColors: [
        { color: "yellow", active: false },
        { color: "blue", active: false },
        { color: "green", active: false },
        { color: "orange", active: false },
        { color: "black", active: true },
        { color: "red", active: false },
      ],
    };
  },
  methods: {
    toggleDropDown() {
      this.isOpen = !this.isOpen;
    },
    closeDropDown() {
      this.isOpen = false;
    },
    toggleList(list, itemToActivate) {
      list.forEach((listItem) => {
        listItem.active = false;
      });
      itemToActivate.active = true;
    },
    updateValue(name, val) {
      this.$emit(`update:${name}`, val);
    },
    changeSidebarBackground(item) {
      this.$emit("update:color", item.color);
      this.toggleList(this.sidebarColors, item);
    },
  },
};
</script>
<style>
.centered-row {
  display: flex;
  height: 100%;
  align-items: center;
}

.button-container .btn {
  margin-right: 10px;
}

.centered-buttons {
  display: flex;
  justify-content: center;
}
</style>
